
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["whitelistpageb_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"128","height":"128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M945.613 194.56H88.627a45.158 45.158 0 00-45.107 45.107V848.59a45.158 45.158 0 0045.107 45.107h856.986a45.158 45.158 0 0045.107-45.107V239.667a45.158 45.158 0 00-45.107-45.107zM88.627 239.667h856.986v64.717H88.627zm0 608.922V349.49h856.986V848.59z"}}),_c('path',{attrs:{"d":"M457.83 444.262a22.58 22.58 0 00-29.337 12.544l-69.223 173.21-69.273-173.21a22.528 22.528 0 00-41.882 16.743l90.215 225.536a22.528 22.528 0 0041.881 0l90.215-225.28a22.528 22.528 0 00-12.596-29.543zm58.573-1.638a22.58 22.58 0 00-22.528 22.63l.768 225.28a22.477 22.477 0 0022.528 22.477 22.528 22.528 0 0022.477-22.63l-.717-225.28a22.528 22.528 0 00-22.528-22.477zm181.146 0h-90.215a22.528 22.528 0 00-22.579 22.58v225.28a22.528 22.528 0 0022.528 22.578 22.477 22.477 0 0022.528-22.476v-67.738h67.43c36.25 0 90.215-24.013 90.215-90.214s-53.658-90.01-89.907-90.01zm0 135.322h-67.277l.256-90.215h66.56c10.65 0 45.312 3.943 45.312 45.107s-34.406 44.954-44.851 45.108z"}})])
          )
        }
      }
    